import { ContractBase } from "./contract-base.model";
import { SupplierFacilityType } from "./supplier-facility-type.model";
import { AuditableEntity } from "./audible-entity.model";
import { FacilityType } from "./facility-type.model";


export class Supplier extends AuditableEntity {

    constructor(_Id?: number, _IsActive?: boolean, _Name?: string,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id;
        this.IsActive = _IsActive || true;
        this.Name = _Name;

        this.SourceFacilityTypes = new Array<FacilityType>();
        this.TargetFacilityTypes = new Array<FacilityType>();
        this.ContractBases = new Array<ContractBase>();
        this.SupplierFacilityTypes = new Array<SupplierFacilityType>();
    }

    public Id: number;
    public IsActive: boolean;
    public Name: string;

    public SourceFacilityTypes: FacilityType[];
    public TargetFacilityTypes: FacilityType[];
    public ContractBases: ContractBase[];
    public SupplierFacilityTypes: SupplierFacilityType[];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/supplier.model.ts